import { z } from "zod";

export const authxAuthorizeResponseSchema = z.object({
  redirect_uri: z.string(),
});

export const authxApplicationSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const accessKeySchema = z.object({
  id: z.string(),
  account_id: z.string().nullish(),
  secret: z.string().nullish(),
  status: z.string().nullish(),
  created_at: z.string().nullish(),
  updated_at: z.string().nullish(),
  deleted_at: z.string().nullish(),
});

export const createAccessKeyResponseSchema = accessKeySchema.extend({
  secret: z.string(),
});

export const ipFiltersSchema = z.object({
  cidrs: z.array(z.string()),
  updated_at: z.string().optional(),
});
